export const WA_NUMBER = "917892712727";
export const EMAIL = "yameen@theelevateestates.com";

export const waLink = (msg) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;

export const WA_MESSAGES = {
  find: "Hi Elevate Estates, I'm looking for a commercial space in Bengaluru. I'd like to discuss available opportunities.",
  list: "Hi Elevate Estates, I'd like to list my commercial property for leasing. Please connect with me.",
  offmarket:
    "Hi Elevate Estates, I'd like to know about off-market commercial opportunities in Bengaluru.",
  talk: "Hi Elevate Estates, I'd like to discuss a commercial real estate requirement.",
  cases:
    "Hi Elevate Estates, I'd like to hear more about your recent engagements and case studies.",
  insights:
    "Hi Elevate Estates, I'd like to receive your market insights on Bengaluru commercial real estate.",
};

export const openModal = (type) =>
  window.dispatchEvent(new CustomEvent("elevate:modal", { detail: type }));

let lenisRef = null;
export const setLenis = (l) => {
  lenisRef = l;
};
export const getLenis = () => lenisRef;
export const scrollToId = (id) => {
  if (lenisRef) lenisRef.scrollTo(id, { duration: 1.5 });
  else document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "For Occupiers", href: "#occupiers" },
  { label: "For Landlords", href: "#landlords" },
  { label: "Insights", href: "#insights" },
  { label: "About", href: "#about" },
];

export const SERVICES = [
  {
    n: "01",
    title: "Retail & F&B Leasing",
    tags: "Restaurants · Cafés · QSRs · Retail · Salons · Gyms · Clinics",
    img: "/assets/img/hotel.jpg",
    modal: "find",
  },
  {
    n: "02",
    title: "Corporate Office Leasing",
    tags: "Corporate offices · GCCs · Grade-A · Managed offices · Flex",
    img: "/assets/img/office.jpg",
    modal: "find",
  },
  {
    n: "03",
    title: "Landlord Representation",
    tags: "Positioning · Marketing · Tenant sourcing · Screening · Negotiation",
    img: "/assets/img/handshake.jpg",
    modal: "list",
  },
  {
    n: "04",
    title: "Location Strategy",
    tags: "Catchment · Footfall · Competition · Visibility · Rental economics",
    img: "/assets/img/night-street.jpg",
    modal: "find",
  },
  {
    n: "05",
    title: "Corporate Real Estate Advisory",
    tags: "Requirement → Search → Shortlist → Negotiation → Closure",
    img: "/assets/img/office2.jpg",
    modal: "find",
  },
  {
    n: "06",
    title: "Investment & Asset Advisory",
    tags: "Asset positioning · Leasing strategy · Acquisition · Exit strategy",
    img: "/assets/img/towers.jpg",
    modal: "list",
  },
];

export const METRICS = [
  { label: "Location", value: 92 },
  { label: "Visibility", value: 88 },
  { label: "Footfall", value: 95 },
  { label: "Accessibility", value: 86 },
  { label: "Rental Economics", value: 79 },
  { label: "Business Suitability", value: 91 },
];

export const MICRO_MARKETS = [
  { name: "Hebbal", x: 390, y: 148, tags: ["Office", "Retail"] },
  { name: "Whitefield", x: 645, y: 250, tags: ["Office", "Retail"] },
  { name: "Indiranagar", x: 512, y: 328, tags: ["Retail", "F&B", "High Street"] },
  { name: "MG Road", x: 415, y: 348, tags: ["Retail", "High Street", "Office"] },
  { name: "CBD", x: 382, y: 395, tags: ["Office", "Retail", "High Street"] },
  { name: "Bellandur", x: 562, y: 432, tags: ["Office", "F&B"] },
  { name: "Koramangala", x: 458, y: 468, tags: ["F&B", "Retail", "Office"] },
  { name: "HSR Layout", x: 522, y: 538, tags: ["F&B", "Retail"] },
  { name: "Jayanagar", x: 348, y: 568, tags: ["Retail", "F&B"] },
  { name: "Outer Ring Road", x: 600, y: 350, tags: ["Office"] },
];

export const CASE_STUDIES = [
  {
    n: "01",
    cat: "F&B",
    title: "Finding the right footprint for a growing food brand.",
    img: "/assets/img/restaurant.jpg",
    meta: {
      LOCATION: "Indiranagar",
      SPACE: "2,800 sq ft",
      REQUIREMENT: "High-street F&B",
      OUTCOME: "Lease secured",
    },
  },
  {
    n: "02",
    cat: "RETAIL",
    title: "Positioning a flagship store on a high-visibility corridor.",
    img: "/assets/img/cafe2.jpg",
    meta: {
      LOCATION: "Koramangala",
      SPACE: "1,600 sq ft",
      REQUIREMENT: "High-street retail",
      OUTCOME: "Lease secured",
    },
  },
  {
    n: "03",
    cat: "OFFICE",
    title: "Securing a managed office for an expanding team.",
    img: "/assets/img/office2.jpg",
    meta: {
      LOCATION: "Outer Ring Road",
      SPACE: "12,000 sq ft",
      REQUIREMENT: "Managed office",
      OUTCOME: "Signed & operational",
    },
  },
];

export const INSIGHTS = [
  {
    cat: "MARKET INTELLIGENCE",
    title: "Where Bengaluru's next retail clusters are emerging",
    img: "/assets/img/skyline.jpg",
  },
  {
    cat: "LOCATION STRATEGY",
    title: "What makes an F&B location commercially viable?",
    img: "/assets/img/cafe.jpg",
  },
  {
    cat: "OFFICE MARKET",
    title: "Bengaluru's evolving corporate office landscape",
    img: "/assets/img/office.jpg",
  },
];
